<template>
  <router-link
    v-if="to"
    :class="componentClasses"
    :to="to"
    :replace="replace"
  >
    <Icon
      v-if="icon"
      :icon="icon"
    />
    <slot />
  </router-link>
  <button
    v-else
    :class="componentClasses"
    @click="$emit('click')"
  >
    <Icon
      v-if="icon"
      :icon="icon"
    />
    <slot />
  </button>
</template>

<script setup>
import { computed } from 'vue';
import Icon from '@stakeui/graphic/icon/Icon.vue';

const props = defineProps({
  active: {
    type: Boolean,
    default: false,
  },
  click: {
    type: Function,
  },
  icon: {
    type: String,
  },
  to: {
    type: Object,
  },
  replace: {
    type: Boolean,
  },
});

const componentClasses = computed(() => [
  'stk-tab-item',
  props.active ? 'is-active' : '',
]);
</script>

<style>
.stk-tab-item {
  border-bottom: 2px solid transparent;
  display: flex;
  margin-bottom: -1px;
  align-items: center;
  justify-content: start;
  font-weight: 500;
  color: var(--stk-text-weak);
  cursor: pointer;
  gap: 0.25em;
  line-height: 1.25;
  padding: 0.375em 1em 0.5em;
  transition-duration: var(--stk-transition-duration);
  transition-property: background-color, color;
  text-align: start;
  justify-content: center;
  text-align: center;

  .stk-icon {
    color: var(--stk-text-weak);
  }

  &:hover {
    color: var(--stk-text-strong);

    .stk-icon {
      color: var(--stk-primary);
    }
  }

  &.router-link-active,
  &.is-active {
    border-bottom-color: var(--stk-primary);
    color: var(--stk-text-strong);

    .stk-icon {
      color: var(--stk-primary);
    }
  }
}

[data-stk-theme="dark"] {
  .stk-tab-item {
    &.is-active {
      background-color: var(--stk-text-30);
      box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.50) inset;
    }
  }
}
</style>
